import {
  handleActions,
} from 'redux-actions';
import update from 'immutability-helper';

import FileActionCreators from '../actions/FileActionCreators';

const {
  fetchFileListRequest,
  fetchFileListSuccess,
  fetchFileListFailure,
  fetchFileURLRequest,
  fetchFileURLSuccess,
  fetchFileURLFailure,
  deleteFileRequest,
  deleteFileSuccess,
  deleteFileFailure,
  getPhotoDownloadURLRequest,
  getPhotoDownloadURLSuccess,
  getPhotoDownloadURLFailure,
} = FileActionCreators;

const pageInfo = {
  number: 0,
  size: 25,
  totalElements: 25,
  totalPages: 1,
};

const initialState = {
  isFileListLoading: false,
  isFileURLLoading: false,
  isDeleteFileLoading: false,
  isPhotoURLLoading: false,
  photoUrl: '',
  fileList: [],
  pageInfo: {},
};

export default handleActions({
  // Requests
  [fetchFileListRequest]: state => update(state, {
    isFileListLoading: { $set: true },
  }),
  [fetchFileURLRequest]: state => update(state, {
    isFileURLLoading: { $set: true },
  }),
  [deleteFileRequest]: state => update(state, {
    isDeleteFileLoading: { $set: true },
  }),
  [getPhotoDownloadURLRequest]: state => update(state, {
    isPhotoURLLoading: { $set: true },
  }),

  // Success
  [fetchFileListSuccess]: (state, { payload }) => update(state, {
    isFileListLoading: { $set: false },
    fileList: { $set: payload },
    pageInfo: { $set: pageInfo },
  }),
  [fetchFileURLSuccess]: state => update(state, {
    isFileURLLoading: { $set: false },
  }),
  [deleteFileSuccess]: state => update(state, {
    isDeleteFileLoading: { $set: false },
  }),
  [getPhotoDownloadURLSuccess]: (state, { payload }) => update(state, {
    isPhotoURLLoading: { $set: false },
    photoUrl: { $set: payload },
  }),

  // Failures
  [fetchFileListFailure]: (state, { payload }) => update(state, {
    isFileListLoading: { $set: false },
    error: { $set: payload.error },
  }),
  [fetchFileURLFailure]: (state, { payload }) => update(state, {
    isFileURLLoading: { $set: false },
    error: { $set: payload.error },
  }),
  [deleteFileFailure]: (state, { payload }) => update(state, {
    isDeleteFileLoading: { $set: false },
    error: { $set: payload.error },
  }),
  [getPhotoDownloadURLFailure]: (state, { payload }) => update(state, {
    isPhotoURLLoading: { $set: false },
    error: { $set: payload.error },
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/file.js